import {
  Route,
  NavLink,
  BrowserRouter,
  Switch,
} from 'react-router-dom'
import React from 'react'
import Home from './pages/Home'
import Login from './pages/Login.js'
import Dashboard from './pages/Dashboard'
import DefaultPage from "./pages/DefaultPage";
import './style/index.scss';
import './style/custom.scss';
import {
  initSiteContext,
  fetchPartner,
} from "./tools/toolbox";
import Register from "./pages/Register";
import AddProduct from './pages/AddProduct';

function App() {
  const [partner, setPartner] = React.useState(false);
  React.useEffect(() => {
    initSiteContext();
    fetchPartner().then(r => r ? setPartner(r) : null);
  }, []);
  // initSiteContext()

  return (
      <BrowserRouter>
          <div>
            <div className="content">
              <Switch>
                <Route exact path="/login" component={Login}/>
                <Route exact path="/home" component={Home}/>
                <Route exact path="/dashboard" component={Dashboard}/>
                <Route exact path="/register" component={Register} />
                <Route exact path="/addproduct" component={AddProduct} />
                <Route component={DefaultPage} />
              </Switch>
            </div>
          </div>
        {/* <ul className="header">
          <li><NavLink to="/login">Login</NavLink></li>
          <li><NavLink to="/home">Home</NavLink></li>
          <li><NavLink to="/dashboard">Dashboard</NavLink></li>
        </ul> */}
      </BrowserRouter>
  );
}

export default App;
